import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  HStack,
  Heading,
  Input,
  Stack,
  Text,
  useBreakpointValue,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import { setAuth, useAppDispatch } from 'core';
import { PasswordField } from 'features';
import { useForm } from 'react-hook-form';
import { Navigate, useLocation } from 'react-router-dom';
import { LOGIN_CACHE_KEY, useLoginMutation } from '../../api';

interface Form {
  email: string;
  password: string;
}
export const LoginForm = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();

  const [loginAsync, { error, isLoading, isSuccess }] = useLoginMutation({
    fixedCacheKey: LOGIN_CACHE_KEY,
  });

  const breakpoint = useBreakpointValue({ base: 'xs', md: 'sm' });
  const colorMode = useColorModeValue('md', 'md-dark');
  const transparentBg = useBreakpointValue({
    base: 'transparent',
    sm: 'bg-surface',
  });
  const location = useLocation();
  const { register, handleSubmit } = useForm<Form>({ mode: 'all' });

  if (isSuccess) {
    const locationState = (location.state as any)?.location as Location;
    const destination = locationState?.pathname || '/app';
    return <Navigate to={destination} replace={true} />;
  }

  return (
    <form
      onSubmit={handleSubmit(async (f) => {
        try {
          const result = await loginAsync(f as any).unwrap();
          dispatch(setAuth(result));
          toast({
            title: `Welcome back, ${result.user.firstName}!`,
            status: 'success',
          });
        } catch (e) {
          console.error('got login err', e);
          // dispatch(showM)
        }
      })}
    >
      <Container
        maxW="lg"
        py={{ base: '12', md: '24' }}
        px={{ base: '0', sm: '8' }}
      >
        <Stack spacing="8">
          <Stack spacing="6">
            {/* <Logo /> */}
            <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
              <Heading size={breakpoint}>Log in to your account</Heading>
              <HStack spacing="1" justify="center">
                <Text color="muted">Don't have an account?</Text>
                <Button variant="link" colorScheme="blue">
                  Sign up
                </Button>
              </HStack>
            </Stack>
          </Stack>
          <Box
            py={{ base: '0', sm: '8' }}
            px={{ base: '4', sm: '10' }}
            bg={transparentBg}
            boxShadow={{ base: 'none', sm: colorMode }}
            borderRadius={{ base: 'none', sm: 'xl' }}
          >
            <Stack spacing="6">
              <Stack spacing="5">
                <FormControl>
                  <FormLabel htmlFor="email">Email</FormLabel>
                  <Input {...register('email')} type="email" />
                </FormControl>
                <PasswordField {...register('password')} />
              </Stack>
              <HStack justify="space-between">
                <Checkbox defaultChecked>Remember me</Checkbox>
                <Button variant="link" colorScheme="blue" size="sm">
                  Forgot password?
                </Button>
              </HStack>
              {error && !isLoading && (
                <Stack spacing="6">
                  <Alert status="error">
                    <AlertIcon />
                    <Box>
                      <AlertTitle>Login Failed</AlertTitle>
                      <AlertDescription>
                        Invalid username or password.
                      </AlertDescription>
                    </Box>
                  </Alert>
                </Stack>
              )}
              {/* <Stack spacing={6}> */}
              {/*   <AutoComplete */}
              {/*     placeholder='You got something?' */}
              {/*     valueFn={(p: Person) => p.id} */}
              {/*     textFn={(p: Person) => p.name} */}
              {/*     items={items} */}
              {/*     value={chosenSelect} */}
              {/*     onChange={text => setChosenSelect(text)}> */}
              {/*     {(p, m) => <AutoCompletionText highlight={m.highlight} text={p.name} />} */}
              {/*   </AutoComplete> */}
              {/* </Stack> */}
              <Stack spacing="6">
                <Button
                  colorScheme="blue"
                  variant="solid"
                  type="submit"
                  isLoading={isLoading}
                  loadingText="Signing In"
                >
                  Sign in
                </Button>
                {/* <Button */}
                {/*   variant="solid" */}
                {/*   type="button" */}
                {/*   onClick={() => { */}
                {/*     toast({ */}
                {/*       title: 'Something happened', */}
                {/*       description: 'Dont be mad at me', */}
                {/*       status: 'warning', */}
                {/*     }); */}
                {/*   }} */}
                {/* > */}
                {/*   Error */}
                {/* </Button> */}
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </form>
  );
};
